module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_RichBlack.e6a55d4c.png";